document.addEventListener('DOMContentLoaded', function () {
  if (window.__lmInit) return;
  window.__lmInit = true;
  initLmFaq();
});

function initLmFaq() {
  var items = document.querySelectorAll('[data-lm-faq-item]');
  if (!items.length) return;
  items.forEach(function (item) {
    var q = item.querySelector('[data-lm-faq-q]');
    if (!q) return;
    q.addEventListener('click', function () {
      var wasOpen = item.classList.contains('lm-open');
      items.forEach(function (i) { i.classList.remove('lm-open'); });
      if (!wasOpen) item.classList.add('lm-open');
    });
  });
}
